export const GET_ACTIVE_SESSIONS = "GET_ACTIVE_SESSIONS";
export const SET_ACTIVE_SESSIONS = "SET_ACTIVE_SESSIONS";
